import template from './stopword-form.html.twig';

const { Component, Mixin } = Shopware;
const { Criteria } = Shopware.Data;

Component.register('topdata-es-mining-stopword-form', {
    template,

    mixins: [
        Mixin.getByName('notification'),
    ],

    props: {
        entity: {
            type: Object,
            required: true,
        },
        repository: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            isLoading: false,
        };
    },

    computed: {
        isNew() {
            return this.entity.isNew();
        },

        modalTitle() {
            return this.isNew
                ? this.$tc('TopdataEnhancedSearchSW6.topdata-es-mining-stopword.modalTitleAdd')
                : this.$tc('TopdataEnhancedSearchSW6.topdata-es-mining-stopword.modalTitleEdit');
        },

        languageOptions() {
            return [
                { value: 'de', label: 'Deutsch' },
                { value: 'en', label: 'English' },
                { value: 'fr', label: 'Français' },
            ];
        },
    },

    methods: {
        getLanguageLabel(languageId) {
            const option = this.languageOptions.find((entry) => entry.value === languageId);
            return option ? option.label : languageId;
        },

        onSave() {
            const word = (this.entity.word || '').trim().toLowerCase();

            if (!word || !this.entity.languageId) {
                return;
            }

            this.entity.word = word;

            const criteria = new Criteria(1, 1);
            criteria.addFilter(Criteria.equals('word', word));
            criteria.addFilter(Criteria.equals('languageId', this.entity.languageId));

            this.isLoading = true;
            this.repository.search(criteria).then((result) => {
                const conflict = result.find((candidate) => candidate.id !== this.entity.id);

                if (conflict) {
                    this.isLoading = false;
                    this.createNotificationError({
                        message: this.$t('TopdataEnhancedSearchSW6.topdata-es-mining-stopword.duplicateWordLanguage', {
                            word,
                            language: this.getLanguageLabel(this.entity.languageId),
                        }),
                    });
                    return;
                }

                this.repository.save(this.entity).then(() => {
                    this.createNotificationSuccess({
                        message: this.$tc('TopdataEnhancedSearchSW6.topdata-es-mining-stopword.saveSuccess'),
                    });
                    this.$emit('save', this.entity);
                }).catch(() => {
                    this.isLoading = false;
                });
            }).catch(() => {
                this.isLoading = false;
            });
        },

        onCancel() {
            this.$emit('cancel');
        },
    },
});
